(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout-chart.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout-chart.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo
} = React;
const HighchartsReact = svs.components.libs.ReactHighcharts;
const {
  CONSTANTS: {
    CHARITY_STATUS
  }
} = svs.lyckoplatsen.components.shared_constants;
const getHighchartsOptions = (payoutChartData, isHorizontal, fontColor) => {
  const uniqueCharities = Array.from(new Map(payoutChartData.map(c => [c.charityId, c])).values());
  const colors = ['#2caffe', '#544fc5', '#00e272', '#fe6a35', '#6b8abc', '#d568fb', '#2ee0ca', '#fa4b42', '#feb56a', '#91e8e1']; 
  if ((uniqueCharities.length - 1) % colors.length === 0 && uniqueCharities.length > colors.length) {
    const newColor = '#FFD700';
    colors.push(newColor);
  }
  return {
    chart: {
      height: isHorizontal ? 100 + 30 * uniqueCharities.length : 384 + 30 * uniqueCharities.length,
      type: 'pie',
      style: {
        fontFamily: 'inherit'
      },
      marginLeft: isHorizontal ? undefined : 0,
      marginRight: isHorizontal ? undefined : 0,
      marginBottom: isHorizontal ? undefined : 40 + 30 * uniqueCharities.length
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    colors,
    legend: {
      enabled: true,
      layout: 'vertical',
      align: isHorizontal ? 'right' : 'left',
      verticalAlign: isHorizontal ? 'middle' : 'bottom',
      x: isHorizontal ? -30 : 25,
      padding: 15,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      itemStyle: {
        fontSize: '18px',
        fontWeight: 'normal',
        color: fontColor
      },
      symbolHeight: 13,
      navigation: {
        enabled: false
      }
    },
    plotOptions: {
      pie: {
        borderRadius: 0,
        states: {
          hover: {
            brightness: 0
          }
        },
        point: {
          events: {
            legendItemClick: () => false
          }
        },
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: [{
      name: 'Procent',
      colorByPoint: true,
      color: 'transparent',
      size: '75%',
      innerSize: '45%',
      data: uniqueCharities === null || uniqueCharities === void 0 ? void 0 : uniqueCharities.map(charity => _objectSpread(_objectSpread({}, charity), {}, {
        id: "".concat(charity.charityId),
        y: charity.percentageOfTotal,
        name: charity.charityId === -1 ? 'Övriga' : charity.charityName
      })),
      tooltip: {
        valueDecimals: 0,
        valueSuffix: '%'
      }
    }]
  };
};
function getFilteredAndCombinedChartData(payoutChartData) {
  const validCharities = payoutChartData.filter(charity => charity.percentageOfTotal > 0);
  const hiddenCharities = validCharities.filter(charity => charity.status === CHARITY_STATUS.HIDDEN);
  if (hiddenCharities.length === 0) {
    return validCharities;
  }
  const combinedHiddenCharities = {
    charityId: -1,
    percentageOfTotal: hiddenCharities.reduce((total, charity) => total + charity.percentageOfTotal, 0),
    name: 'Övriga',
    status: 4
  };
  const nonHiddenCharities = validCharities.filter(charity => charity.status !== CHARITY_STATUS.HIDDEN);
  return [...nonHiddenCharities, combinedHiddenCharities];
}
const CharityPayoutChart = _ref => {
  let {
    payoutChartData = [],
    horizontal = false,
    fontColor = '#fff'
  } = _ref;
  const combinedData = getFilteredAndCombinedChartData(payoutChartData);
  const highchartsOptions = useMemo(() => getHighchartsOptions(combinedData, horizontal, fontColor), [combinedData, horizontal, fontColor]);
  if (!combinedData.length) {
    return React.createElement("div", {
      className: "padding-v-4 padding-h-2"
    }, React.createElement("p", {
      className: "align-center f-bold"
    }, "Vi ber\xE4knar just nu f\xF6rdelningen till organisationerna. Kom tillbaka om en liten stund f\xF6r att se resultatet!"));
  }
  return React.createElement("div", {
    className: "lp-charity-payout-chart"
  }, React.createElement(HighchartsReact, {
    highcharts: Highcharts,
    options: highchartsOptions
  }));
};
setGlobal('svs.lyckoplatsen.components.shared_charity_payout.react.components', {
  CharityPayoutChart
});

 })(window);